<template>
  <div id="periodical-map" :style="{ 'height': height === 0 ? '100vh': height + 'px' }">
    <l-map ref="breakdownMap" :options="{ attributionControl: false, zoomControl: false }" 
      style="height: 100%; width: 100%;" @ready="onMapReady"
      :zoom="zoom" :maxZoom="maxZoom" :minZoom="minZoom" :center="center">
      <l-tile-layer :url="mapStyleUrl" :zIndex="zIndex"></l-tile-layer>
      <l-geo-json 
        v-for="item in geoJsonList"
        :key="item.sourceCode"
        :geojson="item.geoData" 
        :optionsStyle="item.geoJsonStyle"
        :options="item.options"
      >
      </l-geo-json>
      <l-control-zoom :position="'bottomright'"></l-control-zoom>
    </l-map>
  </div>
</template>

<script>
import communicationService from '@/services/PostMessageCommunation/CommunicationService';
import dataKeys from '@/services/PostMessageCommunation/enums/DataKeys';

import { LMap, LTileLayer, LGeoJson, LControlZoom } from 'vue2-leaflet'
import L from 'leaflet';
import periodicalMapHelper from './periodicalMapHelper'

export default {
  components: {
    LMap,
    LTileLayer,
    LGeoJson,
    LControlZoom,
  },
  props: {
    height: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      zoom: 3,
      maxZoom: 6,
      minZoom: 2,
      zIndex: 4,
      center: [44.312223, 30.046882],
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      map: null, // Store the map instance here
    }
  },
  methods: {
    onMapReady(mapInstance) {
      this.map = mapInstance;
    },
    onOpenDetailPage(item) {
      this.$store.dispatch('periodicalResult/fetchSupervisedPeriodDetail', item.id);
      this.$store.state.periodicalResult.isOpenedPeriodicalDetail = true;

      communicationService.sendDataToParent({
        key: dataKeys.STATISTICS,
        value: 'Iframe.ancientDnaAncientOriginsBreakdownPopulationClickFromMap',
      });
    },
  },
  computed: {
    geoJsonList() {
      /* eslint-disable*/
      const currentObject = this;
      let tempOnOpenDetailPage = this.onOpenDetailPage;
      const geoJson = this.$store.getters['periodicalResult/getGeoJson']
      const geoList = geoJson.map(item => {
        if(typeof item.geoData == 'string') {
          try {
            item.geoData = JSON.parse(item.geoData);
          } catch {}
        }
        
        let opacity = parseFloat(item.ancestryValue) / 100;
        opacity = opacity === 0 ? 0.30 : (opacity > 0.5 ? 0.5 : (opacity < 0.07 ? 0.07 : opacity));
        item.geoJsonStyle = {
          fillColor: item.color,
          color: item.color,
          weight: 0,
          fillOpacity: opacity,
        };

        item.options = {
          onEachFeature: function(feature, layer) {
            if (feature.properties) {
              if (currentObject.$store.state.appConfig.windowWidth >= 769) {
                layer.on('mouseover', function(e) { 
                  periodicalMapHelper.injectTooltip(e, item, currentObject);
                });
                layer.on('mousemove', function(e) { 
                  periodicalMapHelper.moveTooltip(e);
                });
                layer.on('mouseout', function() {  
                  periodicalMapHelper.deleteTooltip(); 
                });
              }

              layer.on('click', function() {  
                tempOnOpenDetailPage(item);
              });
            }
          },
        };

        return item;
      });

      return geoList;
    },
    mapStyleUrl() {
      return 'https://api.mapbox.com/styles/v1/myheritage/cm3h3mx73008g01qz5rlh8r7l/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoibXloZXJpdGFnZSIsImEiOiJjbTNoMnBmM20wYXZ3MmpxenZvMWgza3RnIn0.qav_pCmoztqBI9hP2B_RSw';
    },

    proximityId() {
      return this.$store.state.periodicalResult.openedPeriodicalDetail.id;
    },
  },
  watch: {
    proximityId(newId) {
      if (this.map) {
        if (newId) {
          const item = this.geoJsonList.find((item) => item.id === newId);
          if (item && item.geoData) {
            const layer = L.geoJSON(item.geoData);
            const center = layer.getBounds().getCenter();
            const desiredZoomLevel = 5; // Adjust this value as needed
            this.map.setView(center, desiredZoomLevel);
          }
        } else {
          this.map.setView(this.center, this.zoom);
        }
      }
    },
    height() {
      this.$nextTick(() => {
        if (this.map) {
          this.map.invalidateSize();
        }
      });
    },
  },
}

</script>

<style lang="scss" scoped>
</style>
